module.exports = __webpack_public_path__ + "static/media/conference_18.3eaa4d9d.jpeg";